import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { API, formatApiError } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/newsletter", { email });
      if (window.gtag) window.gtag("event", "newsletter_signup", {});
      toast.success("Welcome aboard. The next Dispatch lands in your inbox soon.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex w-full flex-col gap-3 sm:flex-row" data-testid="newsletter-form">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        className="input-lux flex-1"
        data-testid="newsletter-email-input"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-btn"
        className="flex items-center justify-center gap-2 rounded-full bg-gold px-7 py-3 text-sm font-semibold text-navy-deep transition-colors duration-300 hover:bg-gold-light disabled:opacity-60"
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Subscribe <Send className="h-4 w-4" /></>}
      </button>
    </form>
  );
}
